export enum DirtyType {
  Underlying = 'underlying',
  Template = 'template',
}

export type DirtyEntries = {
  [DirtyType.Underlying]: string[];
  [DirtyType.Template]: string[];
};
